"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timelineChart = void 0;
var Highcharts = __importStar(require("highcharts"));
var exporting_1 = __importDefault(require("highcharts/modules/exporting"));
var series_label_1 = __importDefault(require("highcharts/modules/series-label"));
var chart_config_1 = require("./chart-config");
var utils_1 = require("./utils");
var time_chart_1 = require("./time-chart");
(0, exporting_1.default)(Highcharts);
(0, series_label_1.default)(Highcharts);
var createTimeline = function (rangeData, range) {
    var sourceAttributeTuple = Object.entries(time_chart_1.sourceAttribute).map(function (item) {
        return [item[1].name, item[1].code, item[1].color];
    });
    var result = (0, utils_1.filterPoints)(rangeData, range).reduce(function (finalTimeline, point) { return (__assign(__assign({}, finalTimeline), sourceAttributeTuple.reduce(function (aggregator, _c) {
        var _d;
        var name = _c[0], attributeName = _c[1];
        return (__assign({}, (point[attributeName]
            ? __assign(__assign({}, aggregator), (_d = {}, _d[name] = (aggregator[name] || []).concat([new Date(point.month)]), _d)) : aggregator)));
    }, finalTimeline))); }, {});
    var sortedResult = Object.entries(result)
        .sort(function (_c, _d) {
        var aName = _c[0];
        var bName = _d[0];
        return (aName < bName ? -1 : 1);
    })
        .map(function (item) { return __spreadArray(__spreadArray([], item, true), [''], false); });
    // add color
    return sortedResult.map(function (item) {
        var name = item[0];
        item[2] = sourceAttributeTuple.filter(function (value) {
            return value[0] === name;
        })[0][2];
        return item;
    });
};
var timelineChart = function (range, rangeData, timePriceChartData, dateFormatter, labels, renderElement, options) {
    if (options === void 0) { options = {}; }
    var data = createTimeline(rangeData, range);
    return Highcharts.chart({
        chart: {
            renderTo: renderElement,
            height: 180,
            spacing: [1, 1, 1, 1],
        },
        yAxis: {
            labels: {
                enabled: false,
            },
            crosshair: {
                width: 1,
            },
            min: -1,
            max: data.length + 1,
        },
        xAxis: {
            labels: {
                enabled: false,
            },
            tickWidth: 0,
            tickLength: 0,
            lineWidth: 0,
            gridLineWidth: 1,
            gridLineColor: '#ccc',
            gridLineDashStyle: 'Dash',
            categories: labels.map(function (date) {
                try {
                    return dateFormatter(date);
                }
                catch (e) {
                    return String(date);
                }
            }),
        },
        time: {
            useUTC: false,
        },
        plotOptions: {
            series: {
                lineWidth: 2,
                step: 'left',
                marker: {
                    enabledThreshold: 0,
                    symbol: 'circle',
                    radius: 4,
                    states: {
                        hover: {
                            radiusPlus: 2,
                        },
                    },
                },
                states: {
                    inactive: {
                        opacity: 1,
                    },
                },
            },
        },
        series: data.map(function (_c, index) {
            var name = _c[0], timelineDates = _c[1], color = _c[2];
            return ({
                id: name,
                type: 'line',
                step: 'center',
                name: name,
                color: color,
                data: labels.map(function (date) { return ({
                    y: timelineDates.some(function (timelineDate) { return date.toISOString() === timelineDate.toISOString(); }) ? index : null,
                }); }),
            });
        }),
        tooltip: {
            shared: true,
            borderRadius: 0,
            borderWidth: 0,
            padding: 0,
            shadow: false,
            useHTML: true,
            borderColor: '#000000',
            backgroundColor: '#FFFFFF',
            valueDecimals: 2,
            formatter: function () {
                var _this = this;
                return "\n\t\t\t\t\t<div style=\"background: #fff;padding: 6px 8px 8px 8px;border:1px solid #000;\">\n\t\t\t\t\t\t<table cellspacing=\"0\" cellpadding=\"0\" width=\"100%\" class=\"table-timeline-tooltip\">\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<th colspan=\"2\" class=\"tooltip-h2\">" + this.x + "</th>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t" + Object.entries(timePriceChartData)
                    .map(function (_c) {
                    var _ = _c[0], dataset = _c[1];
                    return [
                        _,
                        __assign(__assign({}, dataset), { data: dataset.data.find(function (_c) {
                                var x = _c.x;
                                return dateFormatter(x) === _this.x;
                            }) || null }),
                    ];
                })
                    .filter(function (_c) {
                    var _ = _c[0], dataset = _c[1];
                    return dataset.data;
                })
                    .sort(function (_c, _d) {
                    var _a = _c[0], a = _c[1];
                    var _b = _d[0], b = _d[1];
                    return (b.data.y || 0) - (a.data.y || 0);
                })
                    .reduce(function (completeString, _c) {
                    var name = _c[0], dataset = _c[1];
                    return completeString + "\n\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t<td><i class=\"name-point\" style=\"background: " + time_chart_1.nameColors[name] + "\"></i><span class=\"name-size-300\">" + name + "</span>:&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"td-right\" style=\"text-align: right\"><strong>" + (0, utils_1.formatMoney)(dataset.data.y, 0, options.unit) + "</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>";
                }, '') + "\n\t\t\t\t\t\t</table>\n\t\t\t\t\t</div>\n\t\t\t\t";
            },
            style: {
                color: '#000',
                fontSize: '12px',
                fontFamily: chart_config_1.chartFonts,
            },
        },
        title: {
            text: '',
        },
        subtitle: {
            text: '',
        },
        exporting: {
            enabled: false,
        },
        legend: {
            align: 'center',
            verticalAlign: 'bottom',
            borderWidth: 0,
            x: -2,
            margin: 5,
            symbolWidth: 8,
            symbolHeight: 8,
            symbolRadius: 4,
            itemMarginBottom: 8,
            useHTML: true,
            itemStyle: {
                color: '#333',
                fontWeight: '600',
                fontSize: '11px',
                lineHeight: '16px',
                fontFamily: "'Montserrat', 'system-ui', '-apple-system', 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', 'sans-serif', 'Apple Color Emoji', 'Segoe UI Emoji'",
            },
        },
        credits: {
            enabled: false,
        },
    });
};
exports.timelineChart = timelineChart;
